var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact"},[_c('p',[_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.preferences.author.name))]),_c('br'),_vm._v(" "+_vm._s(_vm.preferences.author.phone)),_c('br'),_vm._v(" "+_vm._s(_vm.preferences.author.email)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }